import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Util } from 'src/app/app.util';

const httpOptions = {
  headers: new HttpHeaders({
      
  }).set('Content-Type', 'application/json')
};

@Injectable({
  providedIn: 'root'
})
export class UserAccessService {

    defaultUrl : String;
    isAdmin: String;
  
    constructor(private http: HttpClient,private util : Util) { 
      this.defaultUrl = util.getBaseUrl();
    }

    private handleError<T>(operation = "operation", result?: T) {
      return (error: any): Observable<T> => {
        console.error(error);
        console.log(`${operation} failed: ${error.message}`);
        return of(result as T);
      };
    }

    getUserAccessRequestList(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "getAccessList";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("getUserAccessRequestList")));
    }

    rejectUserAccessRequest(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "rejectAccess";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("rejectUserAccessRequest")));
    }

    getInitialData(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "getInitialData";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("getInitialData")));
    }

    getDealers(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "getDealers";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("getDealers")));
    }

    getVendorCodes(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "getVendorCodes";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("getVendorCodes")));
    }

    getCustList(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "getCustList";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("getCustList")));
    }

    createUser(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "createUser";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("createUser")));
    }

    getUserList(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "getUserList";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("getUserList")));
    }

    getUserDealerDetails(inputParams):Observable<any>{

        inputParams = JSON.stringify(inputParams);
      
        let initialUrl = this.defaultUrl + "getUserDealer";
      
        console.log("inputParams ",inputParams);
      
        return this.http.post(initialUrl,inputParams,httpOptions)
                .pipe(catchError(this.handleError("getUserDealer")));
    }
}
